import * as React from "react";

import "./pricing-table-modal-3.scss";

import {cs}            from "@Common/react/chain-services";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

import {PricingTable3} from "../../../../../no-enrollment/pricing-table-3/pricing-table-3";

export const PricingTableModal3 = ({title="Pricing", next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3({
        title,
        width: 650,
        // top: 100,
        xdQaName: "Pricing Table Modal",
        next,
        rootNext,
    })],
    ({modal}) => (
        <div className="pricing-table-modal-3-51k">
            <div className="content">
                {PricingTable3({
                    list: modal.params.list, // list of template options
                })}
            </div>

            <div className="footer">
                <button {...{
                    className: "next",
                    onClick: () => modal.close(),

                    "xd-qa-type": "button",
                    "xd-qa-name": "Done",
                }}>
                    Done
                </button>
            </div>
        </div>
    ),
);
